import { AlertCircle, CheckCircle2, XCircle } from 'lucide-react';
import { Badge } from '../Badge';
import { Tooltip } from '../Tooltip';

/**
 * SEMÁFORO — "No alvo / Atenção / Fora da meta", sempre com ícone + texto (2 canais).
 *
 * Quem decide a cor é o SERVIDOR (meta do bloco ou mediana do workspace); aqui só se traduz
 * o veredito. Sem veredito (`null`) não há semáforo — e o componente não renderiza nada, em
 * vez de inventar um cinza que pareceria "neutro".
 */
export type TrafficLightStatus = 'VERDE' | 'AMARELO' | 'VERMELHO';

export interface TrafficLightProps {
  status: TrafficLightStatus | null;
  /** Ex.: "Meta: até 20% · Hoje: 26% · Fora da meta". */
  hint?: string;
  /** Só o ícone (em célula apertada); o texto vai para o rótulo acessível. */
  compact?: boolean;
}

const SPEC = {
  VERDE: { tone: 'success', label: 'No alvo', Icon: CheckCircle2 },
  AMARELO: { tone: 'warning', label: 'Atenção', Icon: AlertCircle },
  VERMELHO: { tone: 'danger', label: 'Fora da meta', Icon: XCircle },
} as const;

export function TrafficLight({ status, hint, compact = false }: TrafficLightProps) {
  if (status === null) return null;
  const { tone, label, Icon } = SPEC[status];
  const badge = (
    <Badge
      tone={tone}
      icon={<Icon aria-hidden="true" className="size-3" />}
      aria-label={hint ? `${label}. ${hint}` : label}
      tabIndex={hint ? 0 : undefined}
    >
      {compact ? null : label}
    </Badge>
  );
  return hint ? <Tooltip content={hint}>{badge}</Tooltip> : badge;
}
